import AoeTypeIcon from "./AoeTypeIcon";

export default AoeTypeIcon;
export { AoeTypeIcon };
